import * as VueRouter from 'vue-router'
import routes from './routes'
import Store from './store'
const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes,
})

router.beforeEach(async (to, from) => {
  // ------------------------------------------------------------
  // check if user needs to be logged in to access this page
  // ------------------------------------------------------------
  const token = localStorage.getItem('token');
  window.Echo.connector.options.auth.headers['Authorization'] = `Bearer ${token}`;
  if ('requiresAuth' in to.meta && to.meta.requiresAuth) {
    await Store.dispatch('auth/me')
  } else {
    if (["login", "register", "forgottenPassword", "resetPassword"].includes(to.name) && Store.getters['auth/authenticated'] === true) {
      return {
        name: 'dashboard',
        replace: true
      }
    }
    return true
  }
})

export default router